import React, { FC } from 'react';
import ICONS from 'components/Icons';

type EmailConfirmationProps = {
  email?: string;
};

const EmailConfirmation: FC<EmailConfirmationProps> = ({ email }) => {
  return (
    <div>
      <p className="row align-center gap-xs title">{ICONS['email']} Check your email</p>
      <p className="row paragraph-small">We have emailed {email} to verify your address.</p>
    </div>
  );
};

export default EmailConfirmation;
